module.exports = {
	catagory: "regional terminology",
	defaultImage: "https://images.unsplash.com/photo-1561911957-98085a69688e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1632&q=80",
	questions: [
		{
			questionText: `What would a Chinese speaker say are the most basic types of tea?`,
			questionDifficulty: 2,
			answerOptions: {
				correct: [
					`Green, Wulong, Red`,
				],
				incorrect: [
					`Iced, Hot`,
					`Green, Black`,
					`Green, White, Black`
				]
			},
			response: `In China the most basic categories of tea are Green, Wulong, and Red - in English that is Green, Oolong, and Black`,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `What do Chinese speakers mean by "black tea" (黑茶)?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Fermented tea"
				],
				incorrect: [
					"Fully oxidized tea",
					"Coffee",
					"Rooibos"
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `What do Chinese speakers mean by "red tea" (红茶)?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Fully oxidized tea"
				],
				incorrect: [
					"Fermented tea",
					"Rooibos",
					"Herbal tea"
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `What do English speakers mean by "black tea"?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Fully oxidized tea"
				],
				incorrect: [
					"Fermented tea",
					"Rooibos"
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `What do S. African English speakers mean by "red tea"?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Rooibos"
				],
				incorrect: [
					"Fermented tea",
					"Fully oxidized tea"
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
	]
}